'kiwi public';

import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import GlobalApi from '@/libs/GlobalApi';
import StateBrowserNetwork from './StateBrowserNetwork';
import StateBrowserUsermenu from './StateBrowserUsermenu';
import AppSettings from './AppSettings';
import BufferSettings from './BufferSettings';
export default {
  components: {
    BufferSettings: BufferSettings,
    StateBrowserNetwork: StateBrowserNetwork,
    StateBrowserUsermenu: StateBrowserUsermenu
  },
  props: ['networks', 'sidebarState'],
  data: function data() {
    return {
      self: this,
      pluginUiElements: GlobalApi.singleton().stateBrowserPlugins,
      activePrompt: {
        type: undefined,
        value: undefined
      }
    };
  },
  computed: {
    getNetwork: function getNetwork() {
      return this.$state.getActiveNetwork();
    },
    isPersistingState: function isPersistingState() {
      return !!this.$state.persistence;
    },
    isRestrictedServer: function isRestrictedServer() {
      return !!this.$state.settings.restricted;
    },
    networksToShow: function networksToShow() {
      var _context;
      return _filterInstanceProperty(_context = this.networks).call(_context, function (net) {
        return !net.hidden;
      });
    }
  },
  created: function created() {
    var _this = this;
    this.listen(this.$state, 'document.clicked', function (e) {
      if (!_this.activePrompt.type) {
        // Prompt is not open
        return;
      }

      // Clicking anywhere on the page that is not a prompt or close button
      // closes the active prompt
      var ignoreClasses = ['.kiwi-statebrowser-prompt-close', '.kiwi-statebrowser-queries-close', '.kiwi-statebrowser-channel-leave'];
      var ignoreEls = _this.$el.querySelectorAll(ignoreClasses.join(', '));

      // ignoreEls.forEach((ignoreEl) => {
      for (var i = 0; i < ignoreEls.length; i++) {
        if (ignoreEls[i].contains(e.target)) {
          return;
        }
      }
      _this.activePrompt.type = undefined;
      _this.activePrompt.value = undefined;
    });
  },
  methods: {
    clickAddNetwork: function clickAddNetwork() {
      var nick = 'Guest' + Math.floor(Math.random() * 100);
      var network = this.$state.getNetworkFromAddress('');
      if (typeof network === 'undefined') {
        network = this.$state.addNetwork('Network', nick, {});
      }
      network.showServerBuffer('settings');
    },
    clickAppSettings: function clickAppSettings() {
      this.$state.$emit('active.component.toggle', AppSettings);
    },
    hideStatebrowser: function hideStatebrowser() {
      this.$state.$emit('statebrowser.hide');
    }
  }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["StateBrowser"]
window._kiwi_exports.components.StateBrowser = (typeof exports !== 'undefined' ? (exports.default || exports) : (typeof module !== 'undefined' && module.exports ? (module.exports.default || module.exports) : {}));
